<template>
  <div class="partnerDetailCard">
    <div class="partnerDetailCardLogo">
      <img v-if="data.image" :src="data.image" :alt="data.name" />
      <div v-else class="partnerDetailCardLogoPlaceholder MyCustomFont">
        {{ data.abbr || "-" }}
      </div>
    </div>
    <div class="partnerDetailCardBody">
      <h2 class="partnerDetailCardName">{{ data.name || "--" }}</h2>
      <p class="partnerDetailCardCredit">统一社会信用代码：{{ creditCode }}</p>
      <div class="partnerDetailCardBadges">
        <div
          v-for="level in levelList"
          :key="level"
          class="partnerDetailCardBadge"
        >
          <img :src="levelIconMap[level]" :alt="level" />
        </div>
      </div>
      <div class="partnerDetailCardLocation">
        <img src="@/assets/images/address.png" alt="" />
        <span>所在地：{{ data.address }}</span>
        <span v-if="data.address && data.businessAddress">,</span>
        <span>{{ data.businessAddress }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import L1 from "@/assets/images/L1.png";
import L2 from "@/assets/images/L2.png";
import L3 from "@/assets/images/L3.png";
import L4 from "@/assets/images/L4.png";

export default {
  name: "PartnerDetailCard",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      levelIconMap: { L1, L2, L3, L4 },
    };
  },
  computed: {
    creditCode() {
      const d = this.data || {};
      return d.creditCode || "-";
    },
    levelList() {
      let names = this.data.equityClassifyNames;

      // 1. 兼容 ['L1、L2、L3、L4'] 这种数组套拼接字符串的情况
      if (
        Array.isArray(names) &&
        names.length === 1 &&
        typeof names[0] === "string"
      ) {
        names = names[0].split("、").map((s) => s.trim());
      } else if (typeof names === "string") {
        names = names.split("、").map((s) => s.trim());
      }
      if (!Array.isArray(names)) return [];

      const levelSet = new Set();
      names.forEach((name) => {
        // 2. 将正则修改为 (L\d+) 以匹配 L 后面接任意数字（如 L1, L2, L3, L4）
        const match = String(name || "").match(/(L\d+)/i);
        if (match) {
          levelSet.add(match[1].toUpperCase());
        }
      });

      const levels = Array.from(levelSet);
      levels.sort((a, b) => {
        const numA = parseInt(a.replace(/L/i, "")) || 0;
        const numB = parseInt(b.replace(/L/i, "")) || 0;
        return numA - numB;
      });
      return levels;
    },
  },
};
</script>

<style lang="less" scoped>
.partnerDetailCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  padding: 32px;
  margin-bottom: 0;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
}
.partnerDetailCardLogo {
  width: 160px;
  height: 160px;
  flex-shrink: 0;
  border: 1px solid #f3f4f6;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
.partnerDetailCardLogoPlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00d8c3;
  color: #fff;
  font-size: 28px;
  text-align: center;
  word-break: break-all;
  padding: 12px;
  box-sizing: border-box;
}
.partnerDetailCardBody {
  flex: 1;
  min-width: 0;
  margin-top: 24px;
  @media (min-width: 768px) {
    margin-top: 0;
    margin-left: 32px;
  }
}
.partnerDetailCardName {
  margin: 0 0 8px;
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.4;
}
.partnerDetailCardCredit {
  margin: 0 0 16px;
  font-size: 14px;
  color: #64748b;
  line-height: 1.4;
}
.partnerDetailCardBadges {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  img {
    height: 24px;
    width: auto;
  }
}
.partnerDetailCardLocation {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64748b;
  img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
</style>
